import big_little_lies from './img/big_little_lies.jpg'
import i_am_watching_you from './img/i_am_watching_you.jpg'
import lock_every_door from './img/lock_every_door.jpg'
import my_last_lie from './img/my_last_lie.jpg'
import my_lovely_wife from './img/my_lovely_wife.jpg'
import the_wife_between_us from './img/the_wife_between_us.jpg'
import you_will_know_me from './img/you_will_know_me.jpg'
import a_wrinkle_in_time from './img/a_wrinkle_in_time.jpg'
import the_dispossessed from './img/the_dispossessed.jpg'
import a_Caribbean_heiress from './img/a_Caribbean_heiress.jpg'
import nora from './img/nora.jpg'
import the_hating from './img/the_hating.jpg'
import athe_notebook from './img/the_notebook.jpg'
import virgin_river from './img/virgin_river.jpg'
import dragon_tattoo from './img/dragon_tattoo.jpg'
import tana_french from './img/tana_french.jpg'
import girl_in_ice from './img/girl_in.jpg'
import pay_dirt_road from './img/pay_dirt_road.jpg'
import where_the_crawdads from './img/where_the_crawdads.jpg'
import ill_we_be_gone_in_the_dark from './img/ill_we_be_gone_in_the_dark.jpg'


export const TPBookItems = [
  {
    id:2001,
    title:"My Last Lie",
    image: my_last_lie,
    price:399,
    
  },
  {
    id:2002,
    title:"I Am Watching You",
    image: i_am_watching_you,
    price:1199,
    
  },
  {
    id:2003,
    title:"Lock Every Door",
    image: lock_every_door,
    price:999,
    
  },
  {
    id:2004,
    title:"My Lovely Wife",
    image: my_lovely_wife,
    price:4999,
    
  },
  {
    id:2005,
    price:2049,
    title: "The Wife Between Us",
    image: the_wife_between_us,
    
  },
  {
    id:2006,
    price:2669,
    title: "You Will Know Me",
    image: you_will_know_me,
    
  },
  {
    id:2007,
    title:"A Wrinkle in Time",
    image: a_wrinkle_in_time,
    price:1199,
    
  },
  {
    id:2008,
    title:"A Caribbean Heiress in Paris",
    image: a_Caribbean_heiress,
    price:1199,
    
  },
  {
    id:2009,
    title:"Big Little Lies",
    image: big_little_lies,
    price:2899,
    
  },
  {
    id:2010,
    title:"Vision in White",
    image: nora,
    price:299,
    
  },
  {
    id:2011,
    price:669,
    title: "The Dispossessed",
    image: the_dispossessed,
    
  },
  {
    id:2012,
    title:"Girl in Ice",
    image: girl_in_ice,
    price:999,
    
  },
  {
    id:2013,
    price:399,
    title: "The Hating Game",
    image: the_hating,
    
  },

{
    id:2014,
    price:13999,
    title: "Virgin River",
    image: virgin_river,
    
  },
  {
    id:2015,
    title:"The Girl with the Dragon Tattoo",
    image: dragon_tattoo,
    price:599,
    
  },
  {
    id:2016,
    price:399,
    title: "The Notebook",
    image: athe_notebook,
  },
  {
    id:2017,
    title:"I'll Be Gone In The Dark",
    image: ill_we_be_gone_in_the_dark,
    price:1929,
    
  },
  {
    id:2018,
    title:"In the Woods",
    image: tana_french,
    price:719,
    
  },
  {
    id:2019,
    price:719,
    title: "Where the Crawdads Sing",
    image: where_the_crawdads,
    
  },
  {
    id:2020,
    title:"Pay Dirt Road",
    image: pay_dirt_road,
    price:599,
    
  },


























];